module.exports = __webpack_public_path__ + "static/img/组 2949.e8d6ab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/aboutUs/images/组 2949.png
// module id = 6TOb
// module chunks = 0